import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';

export type UseEmbedSignFormExperiment = ModelHookResult<{
	isEnabled: boolean;
}>;

export function useEmbedSignFormExperiment(): UseEmbedSignFormExperiment {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionDetailsPageData();

	const {
		data: { decisionMaker, signed, supporterGrowthEmbedSignPetitionFormExperimentVariation },
	} = usePetitionDetailsPageUserData();

	/**
	 * Since other components already take care of displaying other petition states, we only
	 * want to worry about the unsigned state as part of the experiment.
	 */
	return {
		data: {
			isEnabled:
				!signed &&
				!decisionMaker &&
				status !== 'CLOSED' &&
				status !== 'VICTORY' &&
				supporterGrowthEmbedSignPetitionFormExperimentVariation === 'variant_1',
		},
	};
}
